module.exports = __webpack_public_path__ + "img/山楂3.cc83d515.png";